// https://developer.mozilla.org/en-US/docs/Web/Events/resize
import { MEDIA_QUERIES } from '../constants.common/mediaQueries';
import removeFromArray from '../utils.common/removeFromArray';

class ResizeService {
    constructor() {
        let callbacks = [];
        let width = window.innerWidth;
        let height = window.innerHeight;
        let resizeComplete;

        this.heightChangeAmount = 0;
        this.widthChangeAmount = 0;

        this.add = function (callback) {
            if (!callbacks.length) {
                window.addEventListener('orientationchange', resize);
                window.addEventListener('resize', resize);
            }

            addCallback(callback);
        };

        this.remove = function (callback) {
            callbacks = removeFromArray(callbacks, callback);

            if (!callbacks.length) {
                window.removeEventListener('orientationchange', resize);
                window.removeEventListener('resize', resize);
            }
        };

        this.isToMd = function () {
            return matchMedia(MEDIA_QUERIES.toMd).matches === true;
        };

        this.isXl = function () {
            return matchMedia(MEDIA_QUERIES.xl).matches === true;
        };

        this.isMd = function () {
            return matchMedia(MEDIA_QUERIES.md).matches === true;
        };

        this.isLg = function () {
            return matchMedia(MEDIA_QUERIES.lg).matches === true;
        };

        this.isToLg = function () {
            return matchMedia(MEDIA_QUERIES.toLg).matches === true;
        };

        // fired on resize event
        function resize() {
            clearTimeout(resizeComplete);
            resizeComplete = setTimeout(() => {
                if (window.requestAnimationFrame) {
                    window.requestAnimationFrame(runCallbacks);
                } else {
                    setTimeout(runCallbacks, 66);
                }
            }, 250);
        }

        // run the actual callbacks
        function runCallbacks() {
            resizeService.heightChangeAmount = Math.abs(height - window.innerHeight);
            resizeService.widthChangeAmount = Math.abs(width - window.innerWidth);

            // Only run on width changes or if height change is greater than 150px
            if (window.innerWidth != width || window.innerHeight != height) {
                width = window.innerWidth;
                height = window.innerHeight;

                callbacks.forEach(function (callback) {
                    callback();
                });
            }
        }

        // adds callback to loop
        function addCallback(callback) {
            if (callback && callbacks.indexOf(callback) === -1) {
                callbacks.push(callback);
            }
        }
    }
}

const resizeService = new ResizeService();

export default resizeService;
